import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {LeadCreateInput, CreateLead, CreateLeadVariables} from 'nutshell-graphql-types';

import CREATE_LEAD from '../mutations/create-lead.graphql';
import GET_THREAD from '../queries/get-inbox-thread.graphql';

export function useCreateLead() {
    const [createLead, {loading, error}] = useMutation<CreateLead, CreateLeadVariables>(
        CREATE_LEAD
    );

    return {
        createLead: (input: LeadCreateInput, threadId: string) => {
            return createLead({
                variables: {input},
                refetchQueries: [
                    {
                        query: GET_THREAD,
                        variables: {threadId: threadId},
                    },
                ],
                awaitRefetchQueries: true,
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
}
